// extracted by mini-css-extract-plugin
module.exports = {"header":"auF4UKZX","title":"DCQvyPBa","wrapper":"peimC55R","image":"rEjisXoc","loadingWrapper":"PS5wuN9l"};